module.exports = __webpack_public_path__ + "static/media/img_section03_finding01.2a64a252.png";